<template>
  <div class="row w-100 educationForm m-0">
    <!-- Yjs Editor -->
    <b-modal
      v-model="showEditDocumentModal"
      scrollable
      :title="cvEditDocumentModalHeader"
      :noCloseOnBackdrop="true"
      size="xxl"
      hide-header
      hide-footer
    >
      <SpcmEssayEditor :propYJSDocObj="documentEditObj" :propOpenedInModal="true" @emitCloseuserYjsdocsHistoryAddModal="CloseuserYjsdocsHistoryAddModal"/>
    </b-modal><!-- Yjs Editor -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>

    <ValidationObserver ref="extraCurrucularForm" class="row w-100 mt-4">
      <!-- School selection dropdown -->
      <div class="form-group col-6">
        <label for="usp_edu_id">School</label>
        <select v-model="vmExtraCurricularForm['usp_edu_id']" class="form-control" title="Select School" @change="onSchoolChange" :disabled="propOpenedInEditMode">
          <option v-for="(schObj, index) of cvSchoolOptions" :key="(index+1)" :value="schObj.value">
            {{schObj.label}}
          </option>
        </select>
      </div><!-- School selection dropdown -->

      <!-- User's Class, only for display purpouses -->
      <div class="form-group col-6">
        <label for="user_class">Class</label>
        <ValidationProvider name="Class"  v-slot="{ errors }" rules='required'>
          <input readonly :value="userClass" type="text" class="form-control mb-0" id="user_class">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div><!-- User's Class, only for display purpouses -->

      <!-- Extracurricular Type -->
      <div class="form-grou col-12 col-sm-6 col-lg-6" v-if="this.orgDetailhide">
        <label for="exc_type">Document Types&nbsp;<span v-if="propOpenedInEditMode">({{this.selectedExcType}})</span>&nbsp;
          <span class="primary-color pointer" title="Manage Document Types / Topics" @click="OpenDocumentTypeList()">
            <i class="fa-solid ri-pencil-line m-0 font-size-20"></i>
          </span>
        </label>
        <ValidationProvider name="Type"  v-slot="{ errors }" rules='required'>
          <select v-model="vmExtraCurricularForm['exc_type']" title="Extracurricular Documents" class="form-control" @change="onExcTypeChange" :disabled="propOpenedInEditMode">
            <option v-for="(excTypeObj, index) of excTypeList" :key="(index)" :value="excTypeObj.uexcc_type_id">
              {{excTypeObj.uexcc_type_val}}
            </option>
          </select>
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div><!-- Extracurricular Type -->

      <!-- University for which essay is to be submited -->
      <div v-if="this.orgDetailhide">
        <div class="form-group col-12" v-if="selectedExcType && (selectedExcType == 'UNIV_ESSAY' || selectedExcType == 'ADMISSIONOFFERLETTER') ">
          <label for="exc_univ">University</label>
          <multiselect
              v-model="vmExtraCurricularForm['exc_univ']"
              :options="cvUniversityOptions"
              label="label"
              track-by="value"
              :searchable="true"
              :close-on-select="true"
              :allow-empty="false"
              placeholder="Select or search university"
              @input="onUnivChange"
            />
        </div>
      </div><!-- University for which essay is to be submited -->

      <!-- Extracurricular Title / Essay Topic -->
      <div v-if="(selectedExcType && (selectedExcType != 'COMMONAPP_ESSAY' && selectedExcType != 'UNIV_ESSAY')) || !selectedExcType" class="form-group col-6">
        <label for="exc_title">Title</label>
        <ValidationProvider name="Title"  v-slot="{ errors }" rules='required|min:5|max:200'>
          <input v-model="vmExtraCurricularForm['exc_title']" type="text" class="form-control mb-0" id="exc_title">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
      <div v-else class="form-group col-12">
        <!-- These fields get enabled when extracurricular type will be university or commonapp essays -->

        <!-- Loops through all the essay topics for a particular university -->
        <div v-for="(topic, index) in cvEssayTopicOptions" :key="index">
          <p for="exc_title" v-if="cvEssayTopicOptions.length > 0" class="mt-4 ml-2">
            <b>Topic:&nbsp;<span v-html="topic.label"></span></b>
          </p>

          <!-- Extracurricular Description -->
          <div class="form-group col-12" v-if="!propOpenedInEditMode && selectedExcType != 'ADMISSIONOFFERLETTER'" :key="topic.currentWordCount">
            <label for="exc_desc">Essay</label>
            <ValidationProvider name="Description" v-slot="{ errors }">
              <textarea
                autogrow
                v-model="topic['essay']"
                style="height:unset;"
                type="textarea"
                class="form-control mb-0"
                id="exc_desc"
                @input="enforceWordLimit($event, topic)"
              />
              <span v-if="topic['essay']" :class="topic['currentWordCount'] < topic['uexcc_min_length'] || topic['currentWordCount'] > topic['uexcc_max_length'] ? 'text-danger': 'text-success'">
                {{ topic['currentWordCount'] }}&nbsp;/&nbsp;{{ topic['uexcc_max_length']}}&nbsp;Words
              </span>
              <template>
                <small>
                  <span><span class="primary-color">*</span>&nbsp;{{`Min ${topic.uexcc_min_length} words are required`}}</span>&nbsp;
                  <span><span class="primary-color">*</span>&nbsp;{{`Max ${topic.uexcc_max_length} words are allowed`}}</span>
                </small><br>
                <span class="text-danger">{{ errors[0] }}</span>
              </template>
            </ValidationProvider>
          </div><!-- Extracurricular Description -->

          <!-- Google Docs URL input -->
          <div class="form-group col-8">
            <label for="googledoc">Google Docs Link (If any)</label>
            <input v-model="topic.yjsdocs_google_doc_url" type="text" class="form-control mb-0" id="googledoc">
          </div><!-- Google Docs URL input -->
        </div><!-- Loops through all the essay topics for a particular university -->
      </div><!-- Extracurricular Title / Essay Topic -->
      <!-- These fields get enabled when extracurricular type will be university or commonapp essays -->

      <!-- Organisation where the extracurricular activity has been performed or participated -->
      <div class="form-group col-6" v-if="(selectedExcType && (selectedExcType != 'COMMONAPP_ESSAY' && selectedExcType != 'UNIV_ESSAY' && selectedExcType != 'ADMISSIONOFFERLETTER')) || !selectedExcType">
        <label for="exc_org">Organisation</label>
        <ValidationProvider name="Organisation"  v-slot="{ errors }">
          <input v-model="vmExtraCurricularForm['exc_org']" type="text" class="form-control mb-0" id="exc_org" placeholder="Add name of organisation associated with the document">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
      </div><!-- Organisation where the extracurricular activity has been performed or participated -->

      <div class="col-12 mb-4">
        <label></label>
        <label class="p-0 mb-2">
          <b-form-checkbox
            id="checkbox-1"
            v-model="vmExtraCurricularForm['is_extracurricular']"
            name="checkbox-1"
            :value="1"
            :unchecked-value="0"
          >
            Is Personal (Ex. Passport, Aadhar Card, Pan etc. )<br> <small class="primary-color">* These documents are only visible to you and your GIDE Counselor</small>
          </b-form-checkbox>
        </label>
      </div>

      <!-- Extracurricular Title -->
      <div class="form-group col-12" v-if="propOpenedInEditMode">
        <label for="exc_title">Title</label>
        <div v-html="vmExtraCurricularForm['exc_title'].label"></div>
      </div><!-- Extracurricular Title -->

      <!-- These fields will be enabled for extracurriculars apart from university and commonapp essays-->
      <!-- Extracurricular Description -->
      <div class="form-group col-12" v-if="!propOpenedInEditMode && ((selectedExcType && (selectedExcType != 'COMMONAPP_ESSAY' && selectedExcType != 'UNIV_ESSAY' && selectedExcType != 'ADMISSIONOFFERLETTER')) || !selectedExcType)">
        <label for="exc_desc">Description</label>
        <ValidationProvider name="Description" v-slot="{ errors }">
          <textarea
            autogrow
            v-model="vmExtraCurricularForm['exc_desc']"
            style="height:unset;"
            type="textarea"
            class="form-control mb-0"
            id="exc_desc"
            @input="enforceWordLimit"
          />
          <span v-if="vmExtraCurricularForm['exc_desc']" :class="(vmExtraCurricularForm['currentWordCount'] < vmExtraCurricularForm['exc_min_length'] || vmExtraCurricularForm['currentWordCount'] > vmExtraCurricularForm['exc_max_length']) ? 'text-danger': 'text-success'">{{ vmExtraCurricularForm['currentWordCount'] }}&nbsp;/&nbsp;{{ vmExtraCurricularForm['exc_max_length']}}&nbsp;Words</span><br>

          <template>
            <small>
              <span><span class="primary-color">*</span>&nbsp;{{`Min ${vmExtraCurricularForm.exc_min_length} words are required`}}</span>&nbsp;
              <span><span class="primary-color">*</span>&nbsp;{{`Max ${vmExtraCurricularForm.exc_max_length} words are allowed`}}</span>
            </small><br>
            <span class="text-danger">{{ errors[0] }}</span>
          </template>
        </ValidationProvider>
      </div><!-- Extracurricular Description -->
      <!-- Edit Description using yjs editor in edit mode -->
      <div class="form-group col-12" v-if="propOpenedInEditMode">
        <label for="exc_desc">Description
          <span class="pointer primary-color" style="font-size: 1.2rem" title="Edit Description" @click="openYjsEditor(vmExtraCurricularForm)"><i class="fa-solid ri-pencil-line"></i></span>
        </label><br>
        <div v-html="vmExtraCurricularForm['exc_desc']"></div>
      </div><!-- Edit Description using yjs editor in edit mode -->

      <!-- Google Docs URL input -->
      <div class="form-group col-8" v-if="(selectedExcType && (selectedExcType != 'COMMONAPP_ESSAY' && selectedExcType != 'UNIV_ESSAY' && selectedExcType != 'ADMISSIONOFFERLETTER')) || !selectedExcType">
        <label for="googledoc">Google Docs Link (If any)</label>
        <input v-model="vmExtraCurricularForm['yjsdocs_google_doc_url']" type="text" class="form-control mb-0" id="googledoc">
      </div><!-- Google Docs URL input -->
      <!-- These fields will be enabled for extracurriculars apart from university and commonapp essays-->

      <!-- Video Links -->
      <div class="form-group col-10 markRow" v-for="(video, index) in video_link_list" :key="index">
        <label for="exc_video_link">Video Link (Only Youtube links accepted)</label>
        <ValidationProvider name="Video Link"  v-slot="{ errors }">
          <input v-model="video.url" type="text" class="form-control mb-0" id="exc_video_link">
          <span class="text-danger">{{ errors[0] }}</span>
        </ValidationProvider>
        <span class="addIcon">
          <i class="fa-solid fa-circle-plus mr-2" @click="addExcVideoLinkInput()"></i>
          <i class="fa-solid fa-circle-xmark" @click="removeExcVideoLinkInput(index)"></i>
        </span>
      </div><!-- Video Links -->

      <!-- Upload Documents -->
      <div class="row col-12 w-100 ml-1">
        <h6 class="educationTitle w-100 mb-2">Document Showcase (Only PDFs are acceptable, size less than 5mb)&nbsp;&nbsp;
          <label for="excAttachmentFileInput" class="pointer primary-color">(Click here to upload)&nbsp;&nbsp;<i class="fa-solid fa-upload"></i></label>
          <input type="file" accept="application/pdf,image/x-eps" class="dontShow" id="excAttachmentFileInput" @change="onExtraCurricularAttatachmentChange($event, vmExtraCurricularForm, 'excAttachmentFileInput')">
        </h6>
        <template v-if="vmExtraCurricularForm.exc_attach && vmExtraCurricularForm.exc_attach.length">
          <div v-for="(attachment, index) of parseToJSON(vmExtraCurricularForm.exc_attach)" :key="index">
            <div class="attachmentCol">
              <img v-if="attachment.content && attachment.content?.includes('pdf') || attachment.type && attachment.type?.includes('pdf')" :src="pdfLogo" alt="not found" @click="openFile(attachment.url)" :title="vmExtraCurricularForm.exc_attach[0].fileName">
              <img v-else :src="attachment.url" alt="not found" @click="openFile(attachment.url)">
              <span class="addIcon extraCloseIcon" @click="vmExtraCurricularForm.exc_attach.splice(index, 1)"><i class="fa-solid fa-circle-xmark"></i></span>
            </div>
          </div>
        </template>
         <template v-if="vmExtraCurricularForm.yjsdocs_attach && vmExtraCurricularForm.yjsdocs_attach.length">
          <div v-for="(attachment, index) of parseToJSON(vmExtraCurricularForm.yjsdocs_attach)" :key="index">
            <div class="attachmentCol">
              <img v-if="attachment.content && attachment.content?.includes('pdf') || attachment.type && attachment.type?.includes('pdf')" :src="pdfLogo" alt="not found" @click="openFile(attachment.url)">
              <img v-else :src="attachment.url" alt="not found" @click="openFile(attachment.url)">
              <span class="addIcon extraCloseIcon" @click="vmExtraCurricularForm.yjsdocs_attach.splice(index, 1)"><i class="fa-solid fa-circle-xmark"></i></span>
            </div>
          </div>
        </template>
      </div><!-- Upload Documents -->

      <div class="row w-100 pt-4 mb-4 rightAlignDiv mr-4">
        <b-button variant="primary" @click="editExtraCurricularActivity()" v-if="propOpenedInEditMode">Update</b-button>
        <b-button @click="addExtraCurricularActivity()" variant="primary" type="button" v-else>Save</b-button>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import pdfLogo from "../../../assets_gide/img/logo/pdfLogo.png"
import { uexccTypes } from "../../../FackApi/api/UexccType.js"
import { UserProfileExc } from "../../../FackApi/api/userProfileExc.js"
import { User } from "../../../FackApi/api/user.js"
import ApiResponse from "../../../Utils/apiResponse.js"
import Multiselect from "vue-multiselect"
import { YjsDocs } from "../../../FackApi/api/YjsDocs.js"
import SpcmEssayEditor from "../SPCM/SpcmEssayEditor.vue"

export default {
  name: "YjsDocsAttach",
  components: {
    Multiselect,
    SpcmEssayEditor
  },
  props: {
    propUserDetails: {
      type: Object,
      default: null
    },
    propSchoolDetails: {
      type: Object,
      default: null
    },
    propOpenedInEditMode: {
      type: Boolean,
      default: false
    },
    propUspExcId: {
      type: String,
      default: null
    },
    propYJSDocId: {
      type: String,
      default: null
    },
    propOrgId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      excTypeList: [],
      cvEssayTopicOptions: [],
      cvUniversityOptions: [],
      cvSchoolOptions: [],
      userClass: null, // Only for display purpouses, comes from the education details
      vmExtraCurricularForm: {
        exc_type: 1,
        exc_type_key: null,
        exc_type_value: null,
        selectedExcType: null,
        exc_univ: null,
        exc_desc: null,
        exc_attach: [],
        exc_video_link: [],
        is_extracurricular: 0,
        currentWordCount: 0,
        exc_min_length: 50, // Min Words
        exc_max_length: 500 // Max Words
      },
      video_link_list: [{ url: "" }],
      pdfLogo: pdfLogo,
      selectedExcType: null,
      documentEditObj: null,
      showEditDocumentModal: false,
      cvEditDocumentModalHeader: "Edit Document Abouts",
      showToast: false,
      toastVariant: "default",
      toastMsg: null,
      toastTitle: this.propSchoolDetails ? "Extracurriculars" : "Documents",
      orgDetailhide: true
    }
  },
  computed: {
    userData () {
      return { ...this.$store.getters["User/userData"] }
    }
  },
  async mounted () {
    this.populateExcTypes()

    // Resume Builder passes an empty object {} as school details, allowing the user to select the school, so if we want the extracurricular details to be emitted from the component and still want the user to select the school we pass empty object into propSchoolDetails
    if (!this.propSchoolDetails || Object.keys(this.propSchoolDetails).length == 0) {
      this.populateSchoolOptions()
    }
    else {
      this.cvSchoolOptions = [{ value: this.propSchoolDetails.id, label: this.propSchoolDetails.institute_name, class_name: this.propSchoolDetails.education.class_name }]
      this.vmExtraCurricularForm["usp_edu_id"] = this.propSchoolDetails.id
      this.userClass = this.propSchoolDetails.education.class_name
    }

    if (this.propOpenedInEditMode) {
      this.viewUserProfileExc()
    }

    if (this.propOrgId) {
      // Pre-set type and university
      this.vmExtraCurricularForm["exc_type"] = 17
      this.vmExtraCurricularForm["exc_univ"] = this.propOrgId

      // Load types list first
      await this.populateExcTypes()

      // Trigger type change (sets selectedExcType etc)
      await this.onExcTypeChange()

      // Finally load ONLY this university’s topics
      await this.populateEssayTopics(this.propOrgId)

      // Hide Org & other fields
      this.orgDetailhide = false
    }
  },
  methods: {
    /**
     * populateExcTypes
     */
    async populateExcTypes () {
      try {
        let excTypeList = await uexccTypes.userextraccList(this, { get_types_only: true })
        if (!excTypeList.resp_status) {
          ApiResponse.responseMessageDisplay(this, excTypeList)
          return
        }
        this.excTypeList = excTypeList.resp_data.data

        // No need to add essays when the component is opened from user profile and school details are passed into it
        if (this.propSchoolDetails || (this.propSchoolDetail && Object.keys(this.propSchoolDetails).length == 0)) {
          this.excTypeList = this.excTypeList.filter(e => e.uexcc_type_key != "COMMONAPP_ESSAY" && e.uexcc_type_key != "UNIV_ESSAY")
        }
      }
      catch (err) {
        console.error("Exception in populateExcTypes() and err: ", err.message)
      }
    },
    /**
     * populate Essay Topics
     */
    async populateEssayTopics (univId = null) {
      try {
        const payload = {}
        if (univId) {
          payload.uexcc_org_id = univId
        }
        else {
          // Find the type key
          if (!this.propOrgId) {
            let excTypeObj = this.excTypeList.find(e => e.uexcc_type_id == this.vmExtraCurricularForm["exc_type"])
            if (excTypeObj) {
              payload.uexcc_type_key = excTypeObj.uexcc_type_key
            }
            else {
              console.error("Invalid extracurricular type ")
              return
            }
          }
        }

        let essayTopicList = await uexccTypes.userextraccList(this, payload)
        if (!essayTopicList.resp_status) {
          ApiResponse.responseMessageDisplay(this, essayTopicList)
          return
        }

        // Ensure you are accessing the correct depth of the response data
        const essayTopics = essayTopicList.resp_data.data || []

        if (essayTopics.length > 0) {
          // Replace the entire array to trigger Vue reactivity
          this.cvEssayTopicOptions = essayTopics.map((topicObj) => {
            return {
              // If uexcc_type_val is missing, label will be empty
              label: (topicObj.uexcc_type_val || "").replaceAll("\n", "<br/>"),
              value: topicObj.uexcc_type_id, // Use ID for value, not the long text
              essay: "",
              yjsdocs_google_doc_url: "",
              uexcc_type_id: topicObj.uexcc_type_id,
              uexcc_min_length: topicObj.uexcc_min_length,
              uexcc_max_length: topicObj.uexcc_max_length
            }
          })
        }
        else {
          this.cvEssayTopicOptions = []
        }
      }
      catch (err) {
        console.error("Exception in populateEssayTopics() and err: ", err.message)
      }
    },
    /**
     * populate Universities
     */
    async populateUniversities () {
      try {
        let univList = await uexccTypes.userextraccUnivList(this)
        if (!univList.resp_status) {
          ApiResponse.responseMessageDisplay(this, univList)
          return
        }

        univList = univList.resp_data.data
        this.cvUniversityOptions = univList.map((univObj) => {
          return { label: univObj.org_name, value: univObj.org_id }
        })
      }
      catch (err) {
        console.error("Exception in populateUniversities() and err: ", err.message)
      }
    },
    /**
     * populateSchoolOptions
     */
    async populateSchoolOptions () {
      try {
        let userId = null
        if (this.propUserDetails && this.propUserDetails.user_id && (this.userData.user_role == "USERROLE11111" || this.userData.user_role == "USERROLE11118")) {
          userId = this.propUserDetails.user_id
        }
        else {
          userId = this.userData.user_id
        }

        const userProfileResp = await User.userProfileView(this, userId)
        if (!userProfileResp.resp_status) {
          ApiResponse.responseMessageDisplay(this, userProfileResp)
          return
        }
        this.cvSchoolOptions = userProfileResp.resp_data.data.user_profile.education.map((edu) => {
          return { value: edu.id, label: edu.institute_name, class_name: edu.education.class_name }
        })
      }
      catch (err) {
        console.error("Exception in populateSchoolOptions() and err: ", err.message)
      }
    },
    /**
     * onExcTypeChange
     */
    async onExcTypeChange () {
      this.cvEssayTopicOptions = []

      // get the uexcc_type_key(NB: the following code works for exc other than UNIV and COMMON APP essays, they are handled via cvEssayTopicOptions)
      let excTypeKey = this.excTypeList.find(e => e.uexcc_type_id == this.vmExtraCurricularForm["exc_type"])
      if (!excTypeKey) return

      if (excTypeKey) {
        this.selectedExcType = excTypeKey.uexcc_type_key
        if (!this.propOrgId) {
          if (this.selectedExcType == "UNIV_ESSAY" || this.selectedExcType == "ADMISSIONOFFERLETTER") {
            await this.populateUniversities()
            await this.populateEssayTopics()
          }
          else if (this.selectedExcType == "COMMONAPP_ESSAY") {
            await this.populateEssayTopics()
          }
        }

        this.vmExtraCurricularForm.selectedExcType = this.selectedExcType
        this.vmExtraCurricularForm.exc_min_length = excTypeKey.uexcc_min_length
        this.vmExtraCurricularForm.exc_max_length = excTypeKey.uexcc_max_length
        this.vmExtraCurricularForm.exc_type_key = excTypeKey.uexcc_type_key
        this.vmExtraCurricularForm.exc_type_value = excTypeKey.uexcc_type_value
      }
    },
    /**
     * onSchoolChange
     */
    onSchoolChange () {
      let schDetails = this.cvSchoolOptions.find(e => e.value == this.vmExtraCurricularForm["usp_edu_id"])
      if (schDetails) {
        this.userClass = schDetails.class_name
      }
    },
    /**
     * onUnivChange
     */
    onUnivChange (selected) {
      if (this.propOrgId) return

      const univId = selected?.value || selected
      if (univId) {
        this.populateEssayTopics(univId)
      }
    },
    /**
     * onExtraCurricularAttatachmentChange
     */
    onExtraCurricularAttatachmentChange (event, extraCurricular, inputId) {
      const fileList = event.target.files

      if (fileList && fileList.length) {
        for (let file of fileList) {
          if (file.type.includes("pdf")) {
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async (e) => {
              file.url = e.currentTarget.result
              file.fileName = file.name

              if (!extraCurricular.exc_attach) {
                extraCurricular.exc_attach = []
              }

              if (typeof extraCurricular.exc_attach === "string") {
                extraCurricular.exc_attach = JSON.parse(extraCurricular.exc_attach)
              }

              extraCurricular.exc_attach.unshift(file)

              const ele = document.getElementById(inputId)
              if (ele) {
                ele.value = ""
              }
            }
          }
          else {
            alert("Only Pdf allowed")
          }
        }
      }
    },
    /**
     * viewUserProfileExc
     */
    async viewUserProfileExc () {
      try {
        const UserProfileExcViewResp = await UserProfileExc.user_profile_excView(this, this.propUspExcId)
        if (!UserProfileExcViewResp.resp_status) {
          ApiResponse.responseMessageDisplay(this, UserProfileExcViewResp)
          return
        }

        this.vmExtraCurricularForm = UserProfileExcViewResp.resp_data
        if (this.vmExtraCurricularForm["exc_video_link"]) {
          this.vmExtraCurricularForm["exc_video_link"] = this.parseToJSON(this.vmExtraCurricularForm["exc_video_link"])
          this.video_link_list = this.vmExtraCurricularForm["exc_video_link"]
        }

        if (this.vmExtraCurricularForm["exc_attach"]) {
          this.vmExtraCurricularForm["exc_attach"] = this.parseToJSON(this.vmExtraCurricularForm["exc_attach"])
        }

        if (this.vmExtraCurricularForm["uexcc_org_id"]) {
          this.vmExtraCurricularForm["exc_univ"] = this.vmExtraCurricularForm["uexcc_org_id"]
        }

        if (this.vmExtraCurricularForm.deleted == 3) {
          this.vmExtraCurricularForm["is_extracurricular"] = 1
        }

        this.selectedExcType = this.vmExtraCurricularForm["uexcc_type_key"]
        if (this.selectedExcType == "UNIV_ESSAY" || this.selectedExcType == "ADMISSIONOFFERLETTER") {
          this.populateUniversities()
        }
        this.userClass = UserProfileExcViewResp.resp_data.user_class
      }
      catch (err) {
        console.error("Exception in viewUserProfileExc() and err: ", err.message)
      }
    },
    /**
     * addExtraCurricularActivity
     */
    async addExtraCurricularActivity () {
      const valid = await this.$refs.extraCurrucularForm.validate()
      if (!valid) {
        return
      }

      // send only those links which are not empty
      let videoLinks = []
      for (let i = 0; i < this.video_link_list.length; i++) {
        let videoLink = this.video_link_list[i]
        if (videoLink.url.length > 0) {
          videoLinks.push(videoLink)
        }
      }

      if (videoLinks.length > 0) {
        this.vmExtraCurricularForm["exc_video_link"] = videoLinks
      }

      // Extracting the actual ids from the object that is selected while using vue multiselect
      if (this.vmExtraCurricularForm["exc_title"] && typeof this.vmExtraCurricularForm["exc_title"] == "object") {
        this.vmExtraCurricularForm["exc_title"] = this.vmExtraCurricularForm["exc_title"].value
      }

      if (this.vmExtraCurricularForm["exc_univ"] && typeof this.vmExtraCurricularForm["exc_univ"] == "object") {
        this.vmExtraCurricularForm["exc_univ"] = this.vmExtraCurricularForm["exc_univ"].value
      }

      if (this.vmExtraCurricularForm["exc_type"] && typeof this.vmExtraCurricularForm["exc_type"] == "object") {
        this.vmExtraCurricularForm["exc_type"] = this.vmExtraCurricularForm["exc_type"].value
      }

      if (this.vmExtraCurricularForm["usp_edu_id"] && typeof this.vmExtraCurricularForm["usp_edu_id"] == "object") {
        this.vmExtraCurricularForm["usp_edu_id"] = this.vmExtraCurricularForm["usp_edu_id"].value
      }

      const payload = {
        ...this.vmExtraCurricularForm
      }

      if (this.vmExtraCurricularForm.exc_type_key == "UNIV_ESSAY" || this.vmExtraCurricularForm.exc_type_key == "COMMONAPP_ESSAY") {
        payload["essay_topics"] = JSON.stringify(this.cvEssayTopicOptions)
      }

      if (this.propUserDetails && this.propUserDetails.user_id) {
        payload.gide_user_id = this.propUserDetails.user_id
      }

      if (this.propYJSDocId) {
        payload.yjsdocs_id = this.propYJSDocId
      }
      payload.is_extracurricular = this.vmExtraCurricularForm.is_extracurricular ? 1 : 0

      let excpResp = await UserProfileExc.user_profile_excAdd(this, payload)
      if (!excpResp.resp_status) {
        this.toastMsg = excpResp.resp_msg
        this.toastVariant = "danger"
        this.showToast = true
        return
      }

      this.$refs.extraCurrucularForm.reset()
      this.vmExtraCurricularForm = {
        exc_attach: [],
        exc_video_link: [],
        is_extracurricular: 0
      }

      if (this.propSchoolDetails || (this.propSchoolDetail && Object.keys(this.propSchoolDetails).length == 0)) {
        // Opened from Education/Resume Bulder
        this.$emit("emitClosedocAddModal", excpResp.resp_data)
      }
      else {
        // opened from yjsdocs List, we will call the api to refresh the docs list
        this.$emit("emitClosedocAddModal", null)
      }
    },
    /**
     * editExtraCurricularActivity
     */
    async editExtraCurricularActivity () {
      let valid = await this.$refs.extraCurrucularForm.validate()
      if (!valid) {
        return
      }

      // send only those links which are not empty
      let videoLinks = []
      for (let i = 0; i < this.video_link_list.length; i++) {
        let videoLink = this.video_link_list[i]
        if (videoLink.url.length > 0) {
          videoLinks.push(videoLink)
        }
      }

      if (videoLinks.length > 0) {
        this.vmExtraCurricularForm["exc_video_link"] = videoLinks
      }

      // Extracting the actual ids from the object that is selected while using vue multiselect
      if (this.vmExtraCurricularForm["exc_title"] && typeof this.vmExtraCurricularForm["exc_title"] == "object") {
        this.vmExtraCurricularForm["exc_title"] = this.vmExtraCurricularForm["exc_title"].value
      }

      if (this.vmExtraCurricularForm["exc_univ"] && typeof this.vmExtraCurricularForm["exc_univ"] == "object") {
        this.vmExtraCurricularForm["exc_univ"] = this.vmExtraCurricularForm["exc_univ"].value
      }

      if (this.vmExtraCurricularForm["exc_type"] && typeof this.vmExtraCurricularForm["exc_type"] == "object") {
        this.vmExtraCurricularForm["exc_type"] = this.vmExtraCurricularForm["exc_type"].value
      }

      if (this.vmExtraCurricularForm["usp_edu_id"] && typeof this.vmExtraCurricularForm["usp_edu_id"] == "object") {
        this.vmExtraCurricularForm["usp_edu_id"] = this.vmExtraCurricularForm["usp_edu_id"].value
      }

      const payload = {
        ...this.vmExtraCurricularForm
      }

      if (this.propUserDetails && this.propUserDetails.user_id) {
        payload.gide_user_id = this.propUserDetails.user_id
      }

      if (this.vmExtraCurricularForm.is_extracurricular == 1) { // private
        payload.is_extracurricular = 1
        payload.deleted = 3
      }
      else { // public
        payload.is_extracurricular = 0
        payload.deleted = 0
      }
      let excpResp = await UserProfileExc.user_profile_excEdit(this, payload)
      if (!excpResp.resp_status) {
        ApiResponse.responseMessageDisplay(this, excpResp)
        return
      }
      this.$emit("emitClosedocAddModal", excpResp.resp_data)
    },
    /**
     * parseToJSON
     */
    parseToJSON (obj) {
      try {
        if (typeof obj === "string") {
          obj = JSON.parse(obj)
        }
        return obj
      }
      catch (jsonParseEx) {
        console.error("Exception in parseToJSON() and err: ", jsonParseEx)
        throw new Error("Invalid JSON, cammot parse")
      }
    },
    /**
     * openFile
     */
    openFile (url) {
      if (url === "") {
        // empty url means that univ admin has not accepted the application
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "This document can only be viewed after accepting the application"
        return
      }

      window.open(url, "_blank")
    },
    /**
     * addExcVideoLinkInput
     */
    addExcVideoLinkInput () {
      this.video_link_list.push({ url: "" })
    },
    /**
     * removeExcVideoLinkInput
     */
    removeExcVideoLinkInput (index) {
      if (this.video_link_list.length > 1) {
        this.video_link_list.splice(index, 1)
      }
    },
    /**
     * openYjsEditor
     */
    async openYjsEditor (extraCurricular) {
      try {
        let yjsDoc = await YjsDocs.yjsDocsView(this, { yjsdocs_id: extraCurricular.yjsdocs_id })
        if (!yjsDoc.resp_status) {
          ApiResponse.responseMessageDisplay(this, yjsDoc)
          return
        }
        yjsDoc = yjsDoc.resp_data.data
        this.documentEditObj = yjsDoc
        this.showEditDocumentModal = true
      }
      catch (err) {
        console.error("Exception in openYjsEditor() and err: ", err.message)
      }
    },
    /**
     * CloseuserYjsdocsHistoryEditModal
     */
    async CloseuserYjsdocsHistoryAddModal (docData) {
      this.vmExtraCurricularForm["exc_desc"] = docData.yjsdoc
      this.showEditDocumentModal = false
    },
    /**
     * Counts the words in the given text.
     * @param {string} text
     * @returns {number} The number of words.
     */
    countWords (text) {
      // Trim leading/trailing whitespace
      const trimmedText = text.trim()

      if (trimmedText === "") {
        return 0
      }

      // Split by one or more whitespace characters and filter out empty strings
      const words = trimmedText.split(/\s+/).filter(word => word.length > 0)
      return words.length
    },
    /**
     * Updates the counter and enforces the word limit.
     */
    enforceWordLimit (event, univEssayTopic = null) {
      // console.log(this.selectedExcType, "XXXXXXX33333", event, univEssayTopic)

      // let MIN_WORD_LIMIT = this.vmExtraCurricularForm.exc_min_length
      let MAX_WORD_LIMIT = this.vmExtraCurricularForm.exc_max_length
      let text = this.vmExtraCurricularForm["exc_desc"]

      if (this.selectedExcType == "UNIV_ESSAY") {
        // MIN_WORD_LIMIT = univEssayTopic.uexcc_min_length
        MAX_WORD_LIMIT = univEssayTopic.uexcc_max_length
        text = univEssayTopic["essay"]
      }

      let currentWordCount = this.countWords(text)
      if (this.selectedExcType == "UNIV_ESSAY") {
        univEssayTopic.currentWordCount = currentWordCount
      }
      else {
        this.vmExtraCurricularForm.currentWordCount = currentWordCount
      }

      // console.log(MIN_WORD_LIMIT, MAX_WORD_LIMIT, this.selectedExcType, "XXXXX currentWordCount=", currentWordCount)
      if (currentWordCount > MAX_WORD_LIMIT) {
        // 1. If the limit is exceeded, trim the text back to 500 words.
        const words = text.trim().split(/\s+/)

        // Get only the first 500 words and join them back with a single space
        const limitedWords = words.slice(0, MAX_WORD_LIMIT)
        const limitedText = limitedWords.join(" ")

        this.vmExtraCurricularForm["exc_desc"] = limitedText
        currentWordCount = MAX_WORD_LIMIT // Update count after trimming

        // Prevent further input if it's a keydown event (e.g., typing)
        if (event.type === "keydown" && event.key.length === 1) {
          event.preventDefault()
        }
      }
    },
    /**
     * Open the link for managing document types, essay topics etc
     */
    OpenDocumentTypeList () {
      window.open("/uexcc_type_list", "_blank")
    }
  }
}
</script>
<style lang="scss">
  .extraCloseIcon {
    font-size: 18px;
    position: absolute;
    top: 22px;
    cursor: pointer;
    z-index: 99;
    margin-left: -9px;
    color: #e5252c;
  }
  .attachmentCol {
    img {
      height: 32px;
      width: 32px;
      object-fit: contain;
      border: 2px solid aliceblue;
      margin-bottom: 6px;
    }
  }
  .markRow {
    .addIcon {
      float: right;
      margin-top: -42px;
      font-size: 20px;
      position: relative;
      left: 55px;
      cursor: pointer;
      color: #e5252c;
    }
  }
  .rightAlignDiv {
    margin-right: 5%;
    justify-content: end;
    button {
      position: relative;
      left: 25px;
    }
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
